module.exports = __webpack_public_path__ + "img/20200911_140654.e96c4f2f.jpg";